import transverterFn from "i18nData";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import r, { api } from "../../modules/Request";
import arrowdropsicon from "./images/arrowdrops.png";
import arrowriseicon from "./images/arrowrise.png";
import "./index.scss";
export default function EmissionDetail() {
  const { id } = r.getQueryString();
  const visitH5Data = useSelector((state) => state.language);
  // const dispatch = useDispatch();
  const [dataVal, setDataVal] = useState([]);
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [resAll, setResAll] = useState([]); //接口返回的总数据

  const getFillReviewFn = async () => {
    try {
      let res = await r.get(api.LCA_CARBON_REDUCTION_DETAIL + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        document.title = "减排详情";
        setResAll(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (dataVal) {
      console.log(resAll);
      // setResAll(dataVal['zhProductDetail'])

      setStrAll(transverterFn(true));
    }
  }, [visitH5Data, dataVal]);
  useEffect(() => {
    getFillReviewFn();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="emission_detail_box">
        {/* <p className='title'><span style={{fontSize:'.32rem'}}>{strAll?.functionalUnit}</span><span style={{fontSize:'.32rem'}}>{resAll?.featureUnit}</span>/<span style={{fontSize:'.32rem'}}>{resAll?.carbonUnit}</span></p> */}
        <p className="newTitle">
          {/* {strAll?.functionalUnit} */}
          单位：{resAll?.unit}
        </p>
        <div className="emission_detail_title_box">
          <ul className="emission_detail_title">
            <li>
              <p></p>
              <p className="cp_title">
                <div
                  className="emission_margin child_blue"
                  style={{ paddingBottom: 0 }}
                >
                  {strAll?.BasicProduct}
                </div>
              </p>
              <p className="cp_msg">
                <div
                  className="emission_margin child_dark_blue"
                  style={{ paddingBottom: 0 }}
                >
                  减碳产品
                </div>
              </p>
              <p className="cp_val">
                <div
                  className="emission_margin child_green"
                  style={{ paddingBottom: 0 }}
                >
                  {strAll?.Reduction}
                </div>
              </p>
            </li>
            <li>
              <p></p>
              <p className="cp_title">
                <div className="cp_margin">
                  {resAll?.productNameBase || "--"}
                </div>
              </p>
              <p className="cp_msg">
                <div className="cp_margin">
                  {resAll?.productNameImprove || "--"}
                </div>
              </p>
              <p className="cp_val"></p>
            </li>
            <li className="pt-75r">
              <p></p>
              <p className="cp_title">
                <div
                  className="emission_margin child_blue"
                  style={{ fontWeight: "400", paddingBottom: ".21rem" }}
                >
                  {resAll?.carbonBase || "--"}
                </div>
              </p>
              <p className="cp_msg">
                <div
                  className="emission_margin child_dark_blue"
                  style={{ fontWeight: "400", paddingBottom: ".21rem" }}
                >
                  {resAll?.carbonImprove || "--"}
                </div>
              </p>
              <p className="cp_val">
                <div
                  className={`emission_margin ${
                    Number(resAll?.reductionCarbon) > 0
                      ? "child_red"
                      : Number(resAll?.reductionCarbon) < 0
                      ? "child_green"
                      : "child_normal"
                  }`}
                >
                  <div className="img-box">
                    {Number(resAll?.reductionCarbon) > 0 ? (
                      <img src={arrowriseicon} alt="" />
                    ) : Number(resAll?.reductionCarbon) < 0 ? (
                      <img src={arrowdropsicon} alt="" />
                    ) : (
                      <></>
                    )}
                  </div>
                  {Math.abs(resAll?.reductionCarbon) || "--"}
                </div>
              </p>
            </li>
          </ul>
        </div>
        {resAll?.carbonCompareStageRelVOList?.map((items) => {
          return (
            <>
              <div key={items.stepKey} className="head_box">
                <div className="emission_bor">
                  <div className="emission_margin">
                    {items.stepName || "--"}
                  </div>
                </div>
                <div className="emission_bor">
                  <div className="emission_margin">
                    {items.baseUnitCarbon || "--"}
                  </div>
                </div>
                <div className="emission_bor">
                  <div className="emission_margin">
                    {items.reduceUnitCarbon || "--"}
                  </div>
                </div>
                <div className="emission_bor">
                  <div
                    className={`emission_margin ${
                      Number(items.carbonReduceAmplitude) > 0
                        ? "child_red"
                        : Number(items.carbonReduceAmplitude) < 0
                        ? "child_green"
                        : "child_normal"
                    }`}
                  >
                    <div className="img-box">
                      {Number(items.carbonReduceAmplitude) > 0 ? (
                        <img src={arrowriseicon} alt="" />
                      ) : Number(items.carbonReduceAmplitude) < 0 ? (
                        <img src={arrowdropsicon} alt="" />
                      ) : (
                        <></>
                      )}
                    </div>
                    {Math.abs(items.carbonReduceAmplitude)}
                  </div>
                </div>
              </div>
              <div>
                {items.carbonCompareStageRelVOList?.map((item) => {
                  return (
                    <div key={item.stepKey} className="td_box">
                      <div className="emission_bor emission_material">
                        <div className="emission_margin">
                          {item.stepName || "--"}
                        </div>
                      </div>
                      <div className="emission_bor">
                        <div className="emission_margin">
                          {item.baseUnitCarbon || "--"}
                        </div>
                      </div>
                      <div className="emission_bor">
                        <div className="emission_margin">
                          {item.reduceUnitCarbon || "--"}
                        </div>
                      </div>
                      <div className="emission_bor">
                        <div
                          className={`emission_margin ${
                            Number(item.carbonReduceAmplitude) > 0
                              ? "child_red"
                              : Number(item.carbonReduceAmplitude) < 0
                              ? "child_green"
                              : "child_normal"
                          }`}
                        >
                          <div className="img-box">
                            {Number(item.carbonReduceAmplitude) > 0 ? (
                              <img src={arrowriseicon} alt="" />
                            ) : Number(item.carbonReduceAmplitude) < 0 ? (
                              <img src={arrowdropsicon} alt="" />
                            ) : (
                              <></>
                            )}
                          </div>
                          {Math.abs(item.carbonReduceAmplitude)}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}
